import axios from "axios";
import Cookies from "js-cookie";

const handle401Error = () => {
    console.log("401 error");
    // navigate to login page
    // window.location.href = "/admin-login";
//   window.location.href = "/admin-login";
    // remove token from cookies
    // Cookies.remove("accessToken");
    // sessionStorage.removeItem('accessToken')
    // remove token from axios headers
    // delete axios.defaults.headers.common["Authorization"];
};
const handleUser401Error = () => {
    console.log("401 error");
    // navigate to login page
    // window.location.href = "/userlogin";
    // remove token from cookies
    // Cookies.remove("userToken");
    // remove token from axios headers
    // delete axios.defaults.headers.common["Authorization"];
};

const handle500Error = () => {
    console.log("500 error");
}

const handleOtherError = () => {
    console.log("other error");
}

const handleSuccess = () => {
    console.log("success");
}

const handleError = (error) => {
    console.log(error);
    // if (error.response) {
    //     // check if error is 401
    //     if (error.response.status === 401) {
    //         handle401Error();
    //     } else if (error.response.status === 500) {
    //         handle500Error();
    //     } else {
    //         handleOtherError();
    //     }
    // }
    // else if (error.request) {
    //     console.log(error.request);
    //     window.location.href = "/";

    // }
}
const handleUserError = (error) => {
    console.log(error);

    // // check if error is 401
    // if (error.response.status === 401) {
    //     handleUser401Error();
    // } else if (error.response.status === 500) {
    //     handle500Error();
    // } else {
    //     handleOtherError();
    // }
}




// export them so that they can be used in other files in the project and imported automatically
export { handle401Error, handle500Error, handleOtherError, handleSuccess, handleError, handleUserError };


